import { useId, useState, type ReactNode } from 'react';
import { IconChevronDown } from '@tabler/icons-react';
import '@/styles/member.css';

export interface DisclosureProps {
  /** Button text ("More documents (optional)"). */
  label: ReactNode;
  /** Muted second line on the button ("1 added"). */
  hint?: ReactNode;
  defaultOpen?: boolean;
  children: ReactNode;
}

/** A 48 px "show more" row that reveals optional or extra content in place. */
export function Disclosure({ label, hint, defaultOpen = false, children }: DisclosureProps) {
  const [open, setOpen] = useState(defaultOpen);
  const id = useId();
  return (
    <div>
      <button type="button" className="rm-disclosure" aria-expanded={open} aria-controls={id} onClick={() => setOpen((o) => !o)}>
        <span className="lbl">
          {label}
          {hint && <small>{hint}</small>}
        </span>
        <span className="chev" aria-hidden="true"><IconChevronDown size={22} /></span>
      </button>
      <div id={id} hidden={!open}>
        {open && children}
      </div>
    </div>
  );
}
